import { PureComponent } from 'react'
import classNames from 'classnames'

import styles from './index.module.scss'

export default class Fog extends PureComponent {
  render() {
    const { percent } = this.props

    return (
      <div className={classNames(styles.wrap)}>
        <div className={styles.progress}>
        <p className={styles.text}>0</p>
          <div className={styles.bar}>
            <div style={{ width: `${percent}%` }}></div>
          </div>
          <p className={styles.text}>{parseInt(percent) + '%'}</p>
        </div>
      </div>
    )
  }
}
